import { render, staticRenderFns } from "./SitemapIssueBody.vue?vue&type=template&id=3a9baff7&scoped=true"
import script from "./SitemapIssueBody.vue?vue&type=script&lang=js"
export * from "./SitemapIssueBody.vue?vue&type=script&lang=js"
import style0 from "./SitemapIssueBody.vue?vue&type=style&index=0&id=3a9baff7&prod&lang=scss&scoped=true"
import style1 from "./SitemapIssueBody.vue?vue&type=style&index=1&id=3a9baff7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9baff7",
  null
  
)

export default component.exports